import { PkAvatar } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo, useMemo } from 'react';

import { useTranslateFn } from '../Translate';

import { FormGuideOutcome } from '@shared-types/form-guide.types';
import type { Match } from '@shared-types/match.types';
import { matchResult } from '@utilities/live';

import * as styles from './styles.module.scss';

const formGuideMapping = {
  [FormGuideOutcome.WIN]: 'won',
  [FormGuideOutcome.DRAW]: 'draw',
  [FormGuideOutcome.LOSS]: 'lost',
} as const;

const mapFormGuideOutcome = (outcome: FormGuideOutcome, match: Match, teamId: string) =>
  formGuideMapping[outcome] ?? matchResult(match, teamId);

const formGuideColorsMap = {
  won: {
    theme: 'dark',
    color: 'support-01',
  },
  lost: {
    theme: 'dark',
    color: 'support-04',
  },
  draw: {
    theme: 'light',
    color: 'ui-03',
  },
} as const;

const FormGuideAvatar = ({
  outcome,
  match,
  teamId,
  slot = '',
  size = 20,
  className = '',
  textClassName,
  underline = false,
}: {
  outcome: FormGuideOutcome;
  match: Match;
  teamId: string;
  slot?: string;
  size?: number;
  className?: string;
  textClassName?: string;
  underline?: boolean;
}) => {
  const t = useTranslateFn();
  const mappedOutcome = mapFormGuideOutcome(outcome, match, teamId);
  const { color, theme } = useMemo(() => formGuideColorsMap[mappedOutcome], [mappedOutcome]);

  return (
    <PkAvatar
      className={clsx(underline && styles.underline, className)}
      slot={slot}
      size={size}
      pk-theme={theme}
      backgroundColor={color}
      type='text'
    >
      <span className={clsx(styles.text, textClassName)} slot='text'>
        {t(mappedOutcome, { abbr: true })}
      </span>
    </PkAvatar>
  );
};

export default memo(FormGuideAvatar);
